import React, { useState } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Input,
  Row,
  Col,
} from "reactstrap";
import { useMutation } from "@apollo/client";
import { Link, useHistory } from "react-router-dom";
import { SubDirectory } from "utils/defaults";
import { SAlert } from "utils/functions";
import { SMSAlert } from "utils/defaults";
import { SAText } from "utils/functions";
import { CUSTOMER_LOGIN1, CUSTOMER_LOGIN2 } from "graphql/mutations/users";
import { getDeviceFingerprint } from "utils/functions";
import { APPCOOKIE } from "utils/defaults";
import { useAuth } from "components/custom/authprovider";
import { SimpleFormatPhone } from "utils/functions";
import { validatePhoneNumber } from "utils/functions";
import { usePackageId } from "utils/functions";
import { useApolloClient } from "@apollo/client";

function Login() {
  const { setWT, setIsAuthenticated } = useAuth();
  const [customerLogin1] = useMutation(CUSTOMER_LOGIN1);
  const [customerLogin2] = useMutation(CUSTOMER_LOGIN2);
  const [displayname, setUserName] = useState("");
  const [loginmode] = useState("phone");
  const packageId = usePackageId();

  const client = useApolloClient();
  let history = useHistory();

  const TryLogin = () => {
    if (displayname !== undefined && validatePhoneNumber(displayname)) {
      customerLogin1({
        variables: { loginHandle: displayname, loginmode: loginmode },
      })
        .then((r1) => {
          if (r1.data.customerLogin1.status) {
            SendAlert();
          } else {
            SAText("Error", r1.data.customerLogin1.error, "error");
          }
        })
        .catch((err) => {
          SAText("Error", err, "error");
        })
        .finally(() => {
          //TODO: set loading
        });
    } else {
      SAText(
        "Invalid Phone Number",
        "A valid phone number is requried to login",
        "error",
      );
    }
  };

  const SendAlert = () => {
    SAlert(SMSAlert.title, "text", SMSAlert.label, SMSAlert.icon, (v) => {
      customerLogin2({
        variables: {
          loginHandle: displayname,
          loginmode: loginmode,
          code: v,
          fingerprint: getDeviceFingerprint(),
        },
      }).then((r2) => {
        if (r2.data.customerLogin2.status) {
          const TheCookie = {
            wt: r2.data.customerLogin2.token,
            dt: r2.data.customerLogin2.dt,
            p: displayname,
          };
          const token = localStorage.setItem(
            APPCOOKIE,
            JSON.stringify(TheCookie),
          );

          setWT({
            wt: r2.data.customerLogin2.token,
            dt: r2.data.customerLogin2.dt,
            p: displayname,
          });

          setIsAuthenticated({ token });
          client.resetStore();

          // history.push("/" + SubDirectory + "checkout/" + packageId);
          window.location.href = "/" + SubDirectory + "checkout/" + packageId;
        } else
          SAText("Error", r2.data.customerLogin2.error, "error", () =>
            SendAlert(),
          );
      });
    });
  };

  const onEnter = (event) => event.key === "Enter" && TryLogin();

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader className="subTitle">
              WOW Cloud Network Checkout
            </CardHeader>
            <CardBody>
              <Row style={{ margin: "0" }}>
                <Col sm="12" md="6" lg="3" className="mw-Login">
                  <Card className="auctionDetails">
                    <CardHeader>
                      <CardTitle tag="h5">Login Required</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col className="pr-md-1" md="12">
                          <FormGroup>
                            <label className="subTitle">Phone</label>
                            <Input
                              placeholder="Phone"
                              type="text"
                              name="displayname"
                              autoComplete="off"
                              onChange={(e) =>
                                setUserName(SimpleFormatPhone(e.target.value))
                              }
                              value={displayname}
                              onKeyDown={onEnter}
                              autoFocus
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <Button
                        className="btn-fill"
                        color="info"
                        type="button"
                        style={{ width: "100%" }}
                        onClick={() => {
                          TryLogin();
                        }}
                      >
                        Login
                      </Button>

                      <br style={{ clear: "both" }} />
                      <br />

                      <p style={{ textAlign: "center" }}>
                        Don't have an account?{" "}
                        <Link to="/register"> Sign Up </Link> now!{" "}
                      </p>
                    </CardFooter>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Login;
